<template>
  <el-dialog :visible.sync="isShow"
             :width="dw"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             @open='isBtnDisabled = false'
              @close='isBtnDisabled = true'
             custom-class="system_manager_dialog">
    <div class="reason_dialog_title" slot="title">
      <span class="title">{{title}}</span>
      <span class="subTitle">{{subTitle ? `(${subTitle})` : ''}}</span>
    </div>
    <div class="reason_dialog_main">
      <div class="content">
              <textarea v-model.trim="msg"
                        :maxlength="limit"
                        :placeholder="holderText"></textarea>
        <span class="lengthTips">{{msg.length}}/{{limit}}</span>
      </div>
      <div style="margin-bottom:20px">
        <template>
          <label style="margin-right:20px"> 发送成绩通知短信</label>
          <el-radio v-model="radio" label="1">发送</el-radio>
          <el-radio v-model="radio" label="0">不发送</el-radio>
        </template>
      </div>
      
      <div v-if="!verifyBtn" class="btns" >
                <el-button type="primary" class="button" :disabled="isBtnDisabled" @click="doSubmit" :loading="loading">确定</el-button>
                <el-button type="danger" class="button cancel" @click="doCancel">取消</el-button>
                <!-- <div class="btn save"
                     @click="doSubmit">确定</div>
                <div class="btn cancel"
                     @click="doCancel">取消</div> -->
              </div>
      <el-popover  placement="top" width="160" visible-arrow="false" v-model="visible"  v-else>
        <p>{{dialogMsg}}</p>
        <div style="text-align: right; margin: 0" class="popver">
          <el-button type="primary" size="mini" @click="sureSubmit" >确定</el-button>
          <el-button size="mini" type="danger" @click="visible = false" style="background-color:#f00;color:#fff">取消</el-button>
        </div>
<!--        <div v-if="!verifyBtn" slot="reference"-->
<!--           class="btns">-->
<!--        <el-button type="primary" class="button" :disabled="isBtnDisabled" @click="doSubmit">确定</el-button>-->
<!--        <el-button type="danger" class="button cancel" @click="doCancel">取消</el-button>-->
<!--        &lt;!&ndash; <div class="btn save"-->
<!--             @click="doSubmit">确定</div>-->
<!--        <div class="btn cancel"-->
<!--             @click="doCancel">取消</div> &ndash;&gt;-->
<!--      </div>-->
<!--      <div  slot="reference"-->
<!--           class="btns">-->
<!--        <div class="btn ban "-->
<!--          v-if="banBtn">通过</div>-->
        <div class="btn save" slot="reference"
          @click="doVerify('Y')" v-if="!banBtn" >{{buttonText}}</div>
        <div class="btn cancel" slot="reference"
             @click="doVerify('N')" :class="{no_tea:banBtn}">拒绝</div>
<!--      </div>-->
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "Verify",
    mixins: [],
    props: {
      flag: {
        type: Boolean,
        required: true,
        default: false
      },
      dw: {
        type: String,
        required: false,
        default: "450px"
      },
      title: {
        type: String,
        required: false,
        default: "审核理由"
      },
      subTitle: {
        type: String,
        required: false,
        default: ""
      },
      holderText: {
        type: String,
        required: false,
        default: "请输入审核理由"
      },
      limit: {
        type: Number,
        required: false,
        default: 500
      },
      verifyBtn: {
        type: Boolean,
        required: false,
        default: false
      },
      banBtn: {
        type: Boolean,
        required: false,
        default: false
      },
      requiredReason: {
        type: Boolean,
        required: false,
        default: false
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      },
      buttonText:{
        type:String,
        required:false,
        default : '通过'
      }
    },
    data() {
      return {
        msg: "",
        dblClickFlag: false,
        isBtnDisabled: false,
        visible:false,
        radio:'1',
        dialogMsg:''
      };
    },
    computed: {
      isShow: {
        get() {
          if(this.flag) {
            this.dblClickFlag = false;
          }
          return this.flag;
        },
        set(bool) {
          /*
          * 参数一：事件名称
          * 参数二：弹窗visible：值
          * 参数三：关闭弹窗标记，确定(true), 取消(false)
          * 参数四：文本域的值*/
          this.verifyBtn
            ? this.$emit("hideVerify", bool, "", "")
            : this.$emit("hideAdjust", bool, false, "");
          this.clearReason();
        }
      }
    },
    methods: {
      doSubmit() {
        if(this.dblClickFlag) {
          return;
        }
        this.dblClickFlag = true;
        if(this.requiredReason) {
          if(!this.msg) {
            this.$message.error(this.holderText);
            this.dblClickFlag = false
            return;
          }
        }
        this.$emit("hideAdjust", false, true, this.msg);
        // this.clearReason();
      },
      doCancel() {
        this.isShow = false;
      },
      clearReason() {
        this.msg = "";
      },
      doVerify(params) {
        if(this.dblClickFlag) {
          return;
        }
        this.visible=true
        this.params=params

        if (this.buttonText=='通过'){
          this.dialogMsg=params==='Y' ? '确定通过审核吗?' :'确定拒绝审核吗?'
        } else{
          this.dialogMsg=params==='Y' ? '确定推荐吗?' :'确定拒绝吗?'
        }

        // this.dblClickFlag = true;
        // /*
        //   * 参数一：事件名称
        //   * 参数二：弹窗visible：值 (点击按钮true, 点击叉号false)
        //   * 参数三：关闭弹窗标记，通过(Y), 拒绝(N)
        //   * 参数四：文本域的值*/
        // this.$emit("hideVerify", true, params, this.msg);
        // this.clearReason();
      },
      sureSubmit(){
        this.dblClickFlag = true;
        /*
          * 参数一：事件名称
          * 参数二：弹窗visible：值 (点击按钮true, 点击叉号false)
          * 参数三：关闭弹窗标记，通过(Y), 拒绝(N)
          * 参数四：文本域的值
          * 参数五：是否发送短信*/
        this.$emit("hideVerify", true, this.params, this.msg,this.radio);
        this.clearReason();
        this.visible=false

      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable.styl";
  .reason_dialog_title {
    font-weight: bold;
    user-select: none;
    .title {
      color: $color_text_regular;
      font-size: 25px;
    }
    .subTitle {
      margin: 0 0 0 5px;
      color: $color_err;
      font-size: $font_size_medium;
    }
  }
  .reason_dialog_main {
    .content {
      margin: 0 0 20px 0;
      position: relative;
      textarea {
        width: 100%;
        min-height: 100px;
        max-height: 380px;
        resize: vertical;
      }
      .lengthTips {
        position: absolute;
        bottom: 6px;
        right: 6px;
        color: $color_info;
      }
    }
    .btns {
      .el-button--danger {
        width 70px
        /*background-color: #fff;*/

      }
      .button + .button {
        margin-left 30px;
      }
      .ban{
        background-color:$color_info;
        cursor:not-allowed;
      }

    }
  }
  .save{
  width: 80px;
  padding: 10px;
  display: inline-block;
  heigth: 100%;
  background-color: #4cd964;
  text-align: center;
  margin-left: 100px;
  color: #fff;
  cursor pointer
}
  .cancel{
    width 78px
    display inline-block
    heigth 50px
    background-color #f00
    text-align center
    color: #fff
    padding:  9px ;
    /*border 1px solid #000*/
    margin-left 20px
    cursor pointer
  }
  .no_tea{
    margin-left 150px
  }
</style>
<style lang="stylus" >
  .el-popover{
    margin-left 100px
    .popper__arrow{
      display: none
    }
  }
</style>
